import { BrandLogo } from "./Brand";
import { CompanyLogo } from "./CompanyLogo";

/** Subsidiary filter as a row of logo chips (the audience recognises the marks faster than a dropdown). */
export function DivisionChips({ companies, value, onChange, allLabel }: {
  companies: string[];
  value: string;
  onChange: (company: string) => void;
  allLabel: string;
}) {
  const chip = (active: boolean) =>
    `flex shrink-0 items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold transition ${
      active ? "border-brand-primary bg-brand-primary text-white shadow" : "border-brand-grey-light bg-white text-brand-charcoal hover:border-brand-primary"
    }`;
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" role="tablist" aria-label="division">
      <button role="tab" aria-selected={value === ""} onClick={() => onChange("")} className={chip(value === "")}>
        <BrandLogo variant="mark" decorative className={`h-4 rounded-sm ${value === "" ? "bg-white px-0.5" : ""}`} />
        {allLabel}
      </button>
      {companies.map((c) => (
        <button key={c} role="tab" aria-selected={value === c} onClick={() => onChange(c)} className={chip(value === c)}>
          <span className={value === c ? "rounded-sm bg-white px-0.5" : ""}>
            <CompanyLogo company={c} size={16} />
          </span>
          {c}
        </button>
      ))}
    </div>
  );
}
